export function createRolesMap(rateCard) {
  if (
    !rateCard ||
    !Array.isArray(rateCard.serviceGroups) ||
    rateCard.serviceGroups.length === 0
  ) {
    return {};
  }

  return rateCard.serviceGroups.reduce((map, grp) => {
    grp.roles.forEach((role) => {
      map[role.name] = {
        rate: role.rate,
        serviceGroup: grp.name,
      };
    });
    return map;
  }, {});
}
